import { IA_TRAINING_PAGE_IDENTIFIER } from './ia-training.constants';
import {
    SST_MODULE_IDENTIFIER,
    SST_PAGE_IDENTIFIERS,
    SST_ROUTES,
    SST_SECTION_IDENTIFIER,
} from './sst.constants';

export interface AppNavigationEntry {
    moduleLabel: string;
    sectionLabel: string;
    pageLabel: string;
    moduleIdentifier: string;
    sectionIdentifier: string;
    pageIdentifier: string;
    routerLink: string;
    /** Icono PrimeIcons de la página; si no se define se usa el del módulo. */
    icon?: string;
    /** Descripción corta de la página; se muestra como tooltip en el header. */
    description?: string;
    /**
     * Rutas hijas de la página (crear, editar, evaluar…) que no son páginas de Identity: solo
     * aportan su título e icono al header. `path` es relativo a `routerLink`; un segmento
     * `:param` casa con cualquier valor.
     */
    subPages?: AppSubPage[];
}

export interface AppSubPage {
    path: string;
    label: string;
    icon?: string;
}

export const APP_NAVIGATION: AppNavigationEntry[] = [
    {
        moduleLabel: 'Mercadeo',
        sectionLabel: 'Auditoria Retail',
        pageLabel: 'Visitas',
        moduleIdentifier: 'mercadeo',
        sectionIdentifier: 'auditoria-retail',
        pageIdentifier: 'visitas',
        routerLink: '/mercadeo/auditoria-retail/visitas',
        icon: 'pi pi-calendar',
    },
    {
        moduleLabel: 'Mercadeo',
        sectionLabel: 'Auditoria Retail',
        pageLabel: 'Auditorías',
        moduleIdentifier: 'mercadeo',
        sectionIdentifier: 'auditoria-retail',
        pageIdentifier: 'auditorias',
        routerLink: '/mercadeo/auditoria-retail/reporte',
        icon: 'pi pi-chart-line',
    },
    {
        moduleLabel: 'Mercadeo',
        sectionLabel: 'Auditoria Retail',
        pageLabel: 'Resumen Ejecutivo',
        moduleIdentifier: 'mercadeo',
        sectionIdentifier: 'auditoria-retail',
        pageIdentifier: 'resumen_ejecutivo',
        routerLink: '/mercadeo/auditoria-retail/resumen-ejecutivo',
        icon: 'pi pi-clipboard',
    },
    {
        moduleLabel: 'Mercadeo',
        sectionLabel: 'Auditoria Retail',
        pageLabel: 'Resumen por Vendedor',
        moduleIdentifier: 'mercadeo',
        sectionIdentifier: 'auditoria-retail',
        pageIdentifier: 'resumen_vendedor',
        routerLink: '/mercadeo/auditoria-retail/resumen-vendedor',
        icon: 'pi pi-users',
        description: 'Desempeño y KPIs por promotor/vendedor, con drill-down a sus sucursales.',
    },
    {
        moduleLabel: 'Mercadeo',
        sectionLabel: 'Auditoria Retail',
        pageLabel: 'KPI',
        moduleIdentifier: 'mercadeo',
        sectionIdentifier: 'auditoria-retail',
        pageIdentifier: 'kpi',
        routerLink: '/mercadeo/auditoria-retail/kpi',
        icon: 'pi pi-chart-pie',
    },
    {
        moduleLabel: 'Mercadeo',
        sectionLabel: 'Auditoria Retail',
        pageLabel: 'Notificaciones',
        moduleIdentifier: 'mercadeo',
        sectionIdentifier: 'auditoria-retail',
        pageIdentifier: 'notificaciones',
        routerLink: '/mercadeo/auditoria-retail/notificaciones',
        icon: 'pi pi-bell',
    },
    {
        moduleLabel: 'Mercadeo',
        sectionLabel: 'Auditoria Retail',
        pageLabel: 'Mapa PDV',
        moduleIdentifier: 'mercadeo',
        sectionIdentifier: 'auditoria-retail',
        pageIdentifier: 'mapa',
        routerLink: '/mercadeo/auditoria-retail/mapa',
        icon: 'pi pi-map-marker',
    },
    {
        moduleLabel: 'Mercadeo',
        sectionLabel: 'Auditoria Retail',
        pageLabel: 'Datos Maestros',
        moduleIdentifier: 'mercadeo',
        sectionIdentifier: 'auditoria-retail',
        pageIdentifier: 'datos_maestros',
        routerLink: '/mercadeo/auditoria-retail/datos-maestros',
        icon: 'pi pi-database',
        description: 'Sección Mercadeo: organiza catálogos, relaciones operativas y configuraciones de personal.',
    },
    {
        moduleLabel: 'Vitaminas',
        sectionLabel: 'Ecommerce',
        pageLabel: 'Sincronizador',
        moduleIdentifier: 'vitaminas',
        sectionIdentifier: 'ecommerce',
        pageIdentifier: 'sincronizador',
        routerLink: '/vitaminas/ecommerce/sincronizador',
        icon: 'pi pi-sync',
    },
    {
        moduleLabel: 'Vitaminas',
        sectionLabel: 'Ecommerce',
        pageLabel: 'Catálogo Reprico',
        moduleIdentifier: 'vitaminas',
        sectionIdentifier: 'ecommerce',
        pageIdentifier: 'catalogo_reprico',
        routerLink: '/vitaminas/ecommerce/catalogo-reprico',
        icon: 'pi pi-box',
        description: 'Completa la información manual de productos sin coincidencia automática de Franchise.',
    },
    {
        moduleLabel: 'Vitaminas',
        sectionLabel: 'Franquicia',
        pageLabel: 'Listado Aupsa',
        moduleIdentifier: 'vitaminas',
        sectionIdentifier: 'franquicia',
        pageIdentifier: 'listado_aupsa',
        routerLink: '/vitaminas/franquicia/listado-aupsa',
        icon: 'pi pi-list',
        description: 'Registro y arancel AUPSA de los productos de franquicia.',
    },
    {
        moduleLabel: 'Vitaminas',
        sectionLabel: 'Franquicia',
        pageLabel: 'Visita Médica',
        moduleIdentifier: 'vitaminas',
        sectionIdentifier: 'franquicia',
        pageIdentifier: 'visita_medica',
        routerLink: '/vitaminas/franquicia/visita-medica',
        icon: 'pi pi-briefcase',
        description: 'Existencias, costos y precios por producto y bodega.',
    },
    {
        moduleLabel: 'Farmas',
        sectionLabel: 'Reportes',
        pageLabel: 'Ventas por Principio Activo',
        moduleIdentifier: 'farmas',
        sectionIdentifier: 'reports',
        pageIdentifier: 'active_ingredient_sales',
        routerLink: '/farmas/reports/active-ingredient-sales',
        icon: 'pi pi-chart-bar',
        description: 'Ventas agrupadas por principio activo.',
    },
    {
        moduleLabel: 'Farmas',
        sectionLabel: 'Reportes',
        pageLabel: 'Lista de Precios Farmas',
        moduleIdentifier: 'farmas',
        sectionIdentifier: 'reports',
        pageIdentifier: 'farmas_price_list',
        routerLink: '/farmas/reports/farmas-price-list',
        icon: 'pi pi-dollar',
        description: 'Costos, precios SAP (venta, CIF y Farmas) con margen y precios LDCOM por laboratorio.',
    },
    {
        moduleLabel: 'Farmas',
        sectionLabel: 'Reportes',
        pageLabel: 'Compra Sugerida',
        moduleIdentifier: 'farmas',
        sectionIdentifier: 'reports',
        pageIdentifier: 'purchase_logic',
        routerLink: '/farmas/reports/purchase-logic',
        icon: 'pi pi-shopping-cart',
        description: 'Pedido sugerido por artículo padre y sucursal según la venta neta del período.',
    },
    {
        moduleLabel: 'Comercial',
        sectionLabel: 'Configuración',
        pageLabel: 'Ofertas',
        moduleIdentifier: 'comercial',
        sectionIdentifier: 'configuracion',
        pageIdentifier: 'ofertas',
        routerLink: '/comercial/configuracion/ofertas',
        icon: 'pi pi-tags',
        description: 'Las ofertas del motor por estado; desde aquí se crean, editan, publican y cierran.',
        subPages: [
            { path: 'nueva', label: 'Nueva oferta', icon: 'pi pi-plus-circle' },
            { path: ':offerId/editar', label: 'Editar oferta', icon: 'pi pi-pencil' },
        ],
    },
    {
        moduleLabel: 'Comercial',
        sectionLabel: 'Configuración',
        pageLabel: 'Importar ofertas',
        moduleIdentifier: 'comercial',
        sectionIdentifier: 'configuracion',
        pageIdentifier: 'importar_ofertas',
        routerLink: '/comercial/configuracion/ofertas/importar',
        icon: 'pi pi-upload',
        description: 'Sube la hoja de la plantilla, revisa cada fila y crea las ofertas pendientes de aprobación.',
    },
    {
        moduleLabel: 'Farmas',
        sectionLabel: 'Pedidos automáticos',
        pageLabel: 'Cronograma de pedidos',
        moduleIdentifier: 'farmas',
        sectionIdentifier: 'pedidos_automaticos',
        pageIdentifier: 'cronograma_pedidos',
        routerLink: '/farmas/pedidos-automaticos/cronograma',
        icon: 'pi pi-calendar',
        description: 'Cuándo se genera el pedido de cada sucursal, semana a semana.',
    },
    {
        moduleLabel: 'Farmas',
        sectionLabel: 'Pedidos automáticos',
        pageLabel: 'Pedidos generados',
        moduleIdentifier: 'farmas',
        sectionIdentifier: 'pedidos_automaticos',
        pageIdentifier: 'pedidos_generados',
        routerLink: '/farmas/pedidos-automaticos/pedidos',
        icon: 'pi pi-shopping-cart',
        description: 'Los pedidos que produjo el cronograma, con sus líneas y su estado.',
        subPages: [{ path: ':pedidoId/evaluar', label: 'Evaluar pedido', icon: 'pi pi-check-square' }],
    },
    {
        // Una sola bandeja para todo lo que se aprueba: ofertas, pedidos automáticos y lo que
        // venga. Nació en Comercial, pero no es solo comercial: por eso tiene su propio módulo.
        // La campanita y los avisos llegan aquí por esta entrada (APPROVALS_INBOX_ROUTE).
        moduleLabel: 'Centro de aprobaciones',
        sectionLabel: 'Configuración',
        pageLabel: 'Aprobaciones',
        moduleIdentifier: 'centro_aprobaciones',
        sectionIdentifier: 'configuracion',
        pageIdentifier: 'aprobaciones',
        routerLink: '/centro-aprobaciones/configuracion/aprobaciones',
        icon: 'pi pi-check-square',
        description: 'Todo lo que espera tu decisión y lo que tú enviaste a aprobación.',
    },
    {
        moduleLabel: 'Comercial',
        sectionLabel: 'Configuración',
        pageLabel: 'Rent x Labs',
        moduleIdentifier: 'comercial',
        sectionIdentifier: 'configuracion',
        pageIdentifier: 'rent_x_labs',
        routerLink: '/comercial/configuracion/rent-x-labs',
        icon: 'pi pi-percentage',
        description: 'Mínimo de ganancia de Reprico por laboratorio; le gana a la base global.',
    },
    {
        moduleLabel: 'Comercial',
        sectionLabel: 'Configuración',
        pageLabel: 'Clientes Especiales',
        moduleIdentifier: 'comercial',
        sectionIdentifier: 'configuracion',
        pageIdentifier: 'clientes_especiales',
        routerLink: '/comercial/configuracion/clientes-especiales',
        icon: 'pi pi-star',
        description: 'Clientes con un mínimo de ganancia propio, distinto de la base global.',
    },
    {
        moduleLabel: 'Comercial',
        sectionLabel: 'Configuración',
        pageLabel: 'Simulador de ofertas',
        moduleIdentifier: 'comercial',
        sectionIdentifier: 'configuracion',
        pageIdentifier: 'simulador_ofertas',
        routerLink: '/comercial/configuracion/simulador-ofertas',
        icon: 'pi pi-sitemap',
        description: 'Arma una oferta, pruébala con una venta de prueba y mira si le conviene a Reprico antes de crearla.',
    },
    {
        moduleLabel: 'Comercial',
        sectionLabel: 'IA Training',
        pageLabel: 'Images',
        moduleIdentifier: 'comercial',
        sectionIdentifier: 'ia_training',
        pageIdentifier: IA_TRAINING_PAGE_IDENTIFIER,
        routerLink: '/comercial/ia-training/images',
        icon: 'pi pi-images',
        description: 'Imágenes con las que se entrena la IA de Abbot, guardadas en S3.',
    },
    {
        moduleLabel: 'Comercial',
        sectionLabel: 'SST',
        pageLabel: 'Productos',
        moduleIdentifier: SST_MODULE_IDENTIFIER,
        sectionIdentifier: SST_SECTION_IDENTIFIER,
        pageIdentifier: SST_PAGE_IDENTIFIERS.productos,
        routerLink: SST_ROUTES.productos,
        icon: 'pi pi-box',
        description: 'Elige qué productos de SAP entran a la matriz de segmentación StoreTrack.',
    },
    {
        moduleLabel: 'Comercial',
        sectionLabel: 'SST',
        pageLabel: 'Clientes',
        moduleIdentifier: SST_MODULE_IDENTIFIER,
        sectionIdentifier: SST_SECTION_IDENTIFIER,
        pageIdentifier: SST_PAGE_IDENTIFIERS.clientes,
        routerLink: SST_ROUTES.clientes,
        icon: 'pi pi-users',
        description: 'Elige qué clientes de SAP entran a la matriz, por grupo completo o sueltos.',
    },
    {
        moduleLabel: 'Comercial',
        sectionLabel: 'SST',
        pageLabel: 'Matriz',
        moduleIdentifier: SST_MODULE_IDENTIFIER,
        sectionIdentifier: SST_SECTION_IDENTIFIER,
        pageIdentifier: SST_PAGE_IDENTIFIERS.matriz,
        routerLink: SST_ROUTES.matriz,
        icon: 'pi pi-th-large',
        description: 'Asigna o retira qué producto puede vender o tener cada cliente.',
    },
    {
        moduleLabel: 'Salesforce',
        sectionLabel: 'Sincronización',
        pageLabel: 'Productos',
        moduleIdentifier: 'salesforce',
        sectionIdentifier: 'sincronizacion',
        pageIdentifier: 'productos',
        routerLink: '/salesforce/sincronizacion/productos',
        icon: 'pi pi-box',
        description: 'Monitoreo y reintento de sincronización de productos en Salesforce.',
    },
    {
        moduleLabel: 'Salesforce',
        sectionLabel: 'Sincronización',
        pageLabel: 'Inventario',
        moduleIdentifier: 'salesforce',
        sectionIdentifier: 'sincronizacion',
        pageIdentifier: 'inventario',
        routerLink: '/salesforce/sincronizacion/inventario',
        icon: 'pi pi-database',
        description: 'Monitoreo de fallos y reconciliación de inventario en Salesforce.',
    },
];

/**
 * Icono PrimeIcons por módulo. FUENTE ÚNICA: el sidebar y el header lo leen de aquí,
 * tanto para el menú que llega del backend como para el fallback local. Un módulo nuevo
 * se declara arriba en APP_NAVIGATION y su icono aquí; no hay mapas duplicados en servicios.
 */
export const MODULE_ICONS: Readonly<Record<string, string>> = {
    farmacias: 'pi pi-fw pi-building',
    farmas: 'pi pi-fw pi-chart-line',
    mercadeo: 'pi pi-fw pi-megaphone',
    comercial: 'pi pi-fw pi-briefcase',
    centro_aprobaciones: 'pi pi-fw pi-check-circle',
    vitaminas: 'pi pi-fw pi-chart-scatter',
    reportes: 'pi pi-fw pi-chart-bar',
    salesforce: 'pi pi-fw pi-cloud',
    administracion: 'pi pi-fw pi-cog',
    identity: 'pi pi-fw pi-cog',
};

/** Icono por defecto cuando el módulo no está declarado en MODULE_ICONS. */
export const DEFAULT_MODULE_ICON = 'pi pi-fw pi-circle';
